export default __webpack_public_path__ + "static/media/Princess1.83a4c6bd.jpg";